import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { BringzzText } from "@bringzz/components";

const BioText = ({ bio }) => {
  const { t } = useTranslation('pharmacyProfile');
  const [isExpanded, setIsExpanded] = useState(false);

  const { shouldTruncate, displayText } = useMemo(() => {
    if (!bio) return { shouldTruncate: false, displayText: '' };
    
    // Estimate if text will span more than 2 lines (roughly 80 chars per line)
    const estimatedLines = Math.ceil(bio.length / 80);
    
    if (estimatedLines <= 2) {
      return { shouldTruncate: false, displayText: bio };
    }

    // Show approximately 2 lines worth of text when collapsed
    const truncatedText = bio.substring(0, 160);
    
    return {
      shouldTruncate: true,
      displayText: isExpanded ? bio : `${truncatedText}...`
    };
  }, [bio, isExpanded]);

  const handleClick = () => {
    if (shouldTruncate) {
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <div className="space-y-2">
      <BringzzText 
        tag="h5" 
        className={`font-normal ${shouldTruncate ? 'cursor-pointer' : ''}`}
        onClick={handleClick}
      >
        {displayText}
        {shouldTruncate && (
          <span className="text-magic-lilac ml-1 underline">
            {isExpanded ? t('bio.show_less') : t('tabs.posts.read_more')}
          </span>
        )}
      </BringzzText>
    </div>
  );
};

export default BioText; 